<div class="modal-header modal-primary">
    <h4 class="modal-title" style="font-family: 'Courier New', Courier, monospace;">You have unsaved changes. Do you want to leave this page?</h4>
</div>
<!-- <div class="modal-body clearfix">
    <div class="modal-text">
        <div class="alert alert-danger alertMSG" role="alert">
            
        </div>
    </div>
</div> -->
<div class="modal-footer">
    <button class="btn btn-primary font-weight-bolder" (click)="action(true)">Leave </button>
    <button class="btn btn-success font-weight-bolder" (click)="action(false)"> Stay</button>
</div>